import { apiRoutesValueT } from "../constants";

export type stagesRoutesNameT =
  | "GET_STAGES"
  | "UPDATE_STAGE"
  | "CREATE_STAGE"
  | "DELETE_STAGE"
  | "RETRIEVE_STAGE";
type stagesRoutesT = Record<stagesRoutesNameT, apiRoutesValueT>;

const api = process.env.REACT_APP_API_URL;

export const stagesRoutes: stagesRoutesT = {
  GET_STAGES: {
    url: `${api}/stages`,
    request: "get",
  },
  CREATE_STAGE: {
    url: `${api}/stages`,
    request: "post",
  },
  UPDATE_STAGE: {
    url: `${api}/stages`,
    request: "put",
  },
  DELETE_STAGE: {
    url: `${api}/stages`,
    request: "delete",
  },
  RETRIEVE_STAGE: {
    url: `${api}/stages`,
    request: "get",
  },
};
